var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-auto mt-4 maxWidth-1100"},[_c('h1',{staticClass:"shio-section-title"},[_vm._v(_vm._s(_vm.$t( "signedin.Profile" )))]),_c('div',{staticClass:"px-1"},[_c('signhero-user-profile',{staticClass:"elevation-1 mt-5",attrs:{"optional_properties":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }